import { FileText, Phone, ArrowRight } from "lucide-react";
import { PHONE_HREF } from "@/components/site/availableCatalog";
import { track } from "@/lib/track";

export default function CareGuideBanner() {
  return (
    <section
      data-testid="care-guide-banner"
      className="bg-[#C8B387] text-[#1F1E1C] border-b border-[#B39F73]"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-14 py-4 md:py-5 flex flex-col md:flex-row md:items-center gap-3 md:gap-8">
        <div className="flex items-center gap-3 flex-1">
          <FileText size={20} strokeWidth={1.5} className="flex-shrink-0" />
          <p className="text-sm md:text-[15px] leading-snug">
            <span className="font-semibold tracking-wide uppercase text-[12px] mr-2">
              Free Guide
            </span>
            The Fountain Care Guide walks you through cleaning and winterizing,
            step by step. Rather not mess with it?{" "}
            <a
              href={PHONE_HREF}
              onClick={() => track("call_click", "Care guide banner")}
              data-testid="care-guide-banner-call"
              className="underline underline-offset-2 font-medium hover:text-[#5C4A2E] transition-colors whitespace-nowrap"
            >
              <Phone size={11} strokeWidth={1.5} className="inline mr-1 -mt-0.5" />
              Call Chris
            </a>
          </p>
        </div>
        <a
          href="/fountain-care-guide.pdf"
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => track("care_guide_click", "Care guide banner")}
          data-testid="care-guide-banner-download"
          className="inline-flex items-center justify-center gap-2 px-5 py-2.5 bg-[#1F1E1C] text-[#F9F6F0] text-[11px] tracking-[0.2em] uppercase hover:bg-[#5C4A2E] transition-colors flex-shrink-0"
        >
          Download the PDF
          <ArrowRight size={13} strokeWidth={1.5} />
        </a>
      </div>
    </section>
  );
}
